// extracted by mini-css-extract-plugin
export default {"root":"SkeletonChart_root__1sZgw"};